export const initYagaButtons = () => {
	const yagaButtons = document.querySelectorAll( '[data-yaga]' );

	if ( !yagaButtons.length )
	{
		return;
	}

	Array.from( yagaButtons ).forEach( ( it ) => {
		if ( it.dataset.yaga === '' )
		{
			return;
		}

		it.addEventListener( 'click', ( evt ) => {
			const values = it.dataset.yaga.split( ',' );

			[yaga_metrika, yaga_ga_cat, yaga_ga_act, yaga_ga_label] = values;
		} );
	} );
};